import { Container } from "reactstrap";
import { BackLink, ToastContainer } from "../../components/Common";
import JobDetailsPageLogic from "./page";

const JobDetailsPageWrapper = () => {
    return (
        <div className="page-content">
            <Container fluid>
                <BackLink />
                <JobDetailsPageLogic />
            </Container>
            <ToastContainer />
        </div>
    );
};

export default JobDetailsPageWrapper;
